import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"error\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18z\" fill=\"#FF534A\" /><path d=\"M11.827 6.17l-5.656 5.657M6.17 6.17l5.658 5.657\" stroke=\"#fff\" stroke-width=\"1.25\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol